<re-process-failed-users title="Import Users to IDM" (loaded)="load($event)" [hideSsoId]="true">

</re-process-failed-users>
